/** A US number as people write it, "(949) 555-0142"; anything else as it came (E.164 from Twilio). */
export function formatPhone(value: string): string {
  const us = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(value);
  return us === null ? value : `(${us[1] ?? ""}) ${us[2] ?? ""}-${us[3] ?? ""}`;
}
